export const CustomProjectStep1ElementsIdsEnum = {
    CREATE_PROJECT_DATA_SECTION: 'createProjectDataSet',
    PROJECT_TITLE_FIELD: 'projectTitleField',
    TEMPLATE_MEASUREMENTS_STEP1_SECTION: 'templateMeasurementsStep1Section',
    TEMPLATE_MEASUREMENTS_STEP1_FIELD: 'templateMeasurementsStep1Field',
    TEMPLATE_MEASUREMENTS_STEP1_FILLING_SECTION:
        'templateMeasurementsStep1FillingSection',
    CREATE_PROJECT_STEP1_NEXT_BUTTON: 'createProjectStep1NextButton',
} as const;

export type CustomProjectStep1ElementsIdsType =
    (typeof CustomProjectStep1ElementsIdsEnum)[keyof typeof CustomProjectStep1ElementsIdsEnum];
